import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CalendarService} from '../../../../../components/calendar/calendar.service';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import {AppConstants} from '../../../../../app.constants';
import {MessageService} from 'primeng/components/common/messageservice';
import {CalendarFirebaseService} from '../../../../../components/calendar/calendarfirebase.service';
import {LocalStorageService} from 'ng2-webstorage';
import {DatePipe} from '@angular/common';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';

@Component({
  selector: 'addevent',
  templateUrl: 'ParentDRCAccess.component.html',
  styleUrls: ['ParentDRCAccess.component.scss']
})



export class ParentDRCAccessComponent implements OnInit {
  public En: any;
  public Es: any;
  public Ep: any;
  public Gs: any;
  public MappedData: any;

  public selectAllGrades: boolean = false;


  public isentireClass: boolean;
  public parentsList = [];
  public selectedParents = [];
  public singleselectedParents = [];
  public checks: boolean;
  public checks2: boolean;
  public selectAllFlag: boolean;
  public selectAllSectionFlag: boolean;
  public selectedStd = [];
  public selectedStd1 = [];
  public selectall: boolean;
  public entireschoolFlag: boolean = false;
  public allStudentFlag: boolean = false;
  selectedStandardIds: any[] = [];
  selectedSectionIds: any[] = [];
  public totalparents: number;
  public term: any;
  public selectedStandardSection = [];
  public isAllSectionsSelected: boolean;
  public selectSectionCount: number = 0;
  public standardName: any;
  public sectionName: any;
  public parentsListData = [];
  public selectedParentsList = [];
  public adminUserFlag: boolean;
  public priorityFlag: boolean;

  yearId: any;
  yearname: any;
  selectedYear: any;
  YearData: any = [];

  public allStudentsFirst:boolean=false;
  public allStudentsSecond:boolean=false;
  public allStudentsThird:boolean=false;

  public tempParentsListData = [];



  constructor(private router: Router,
              private noticeboardService: NoticeboardService,
              private activateroute: ActivatedRoute,
              private localStorage: LocalStorageService,
              private dataAnalyticsService: DataAnalyticsService,
              private messageService: MessageService){
  }



  ngOnInit(): void {
    this.adminUserFlag = this.localStorage.retrieve("IsSchoolAdminUser");
    this.getYearData();
    this.getClassSection();
  }


  private getYearData() {
    this.dataAnalyticsService.getYear()._finally(() => { }).subscribe(
      response => {
        this.YearData = response['yearList'];
        this.YearData.sort((a, b) => b.AcademicYear.localeCompare(a.AcademicYear));

        try {
          this.selectedYear = this.YearData[0];
        } catch (error) {

        }

        console.log(response )
      }
    )
  }


  getYearList(year) {
    console.log(year);
    this.selectedStd = [];
    this.parentsList = [];
    this.yearId = year.YearId;
    this.yearname = year.AcademicYear;
    this.selectAllGrades =false;
    //this.nameofstudent = [];
    //this.getClassSection()
    console.log(this.yearname)
    console.log(this.yearId)

  }


  private getClassSection() {
    this.noticeboardService
      .getClassSectionMap()
      .finally(() => {})
      .subscribe(
        (response) => {
          console.log(response);
          let mappedData: any = response;
          mappedData.forEach((standard) => {
            standard["Sections"].forEach((section) => {
              section["StdId"] = standard["standardId"];
              section["StdName"] = standard["standardsName"];
              section["selected"] = false;
            });
          });
          mappedData.sort((a, b) =>
            ("" + a.standardsName).localeCompare(b.standardsName, undefined, {
              numeric: true,
            })
          );
          if (this.adminUserFlag) {
            this.MappedData = mappedData;
            this.priorityFlag = true;
          } else {
            this.MappedData = mappedData;
          }
        },
        (error) => {}
      );
  }




  selectAllGradesSchool(e) {
    if (e.target.checked) {
      this.selectAllGrades = true;

      this.selectedStd = this.MappedData;

      this.selectedStd.forEach(element => {
        element.Sections.sort((a, b) => {
          if (a.sectionName < b.sectionName) {
            return -1;
          }
          if (a.sectionName > b.sectionName) {
            return 1;
          }
          return 0;
        });
      });
    }else {
      this.selectAllGrades = false;
      this.selectedStd = [];
      this.parentsList = [];
    }
    console.log(this.selectedStd);
  }






  verify(e) {
    console.log(this.MappedData);
    console.log('verify');
    this.isentireClass = false;
    this.parentsList = [];
    this.selectedParents = [];
    this.singleselectedParents = [];
    if (e.target.checked) {
      this.checks2 = true;
      this.entireschoolFlag = true;
      this.selectAllSectionFlag = false;
      this.MappedData.map((element) => {
        element.checkFlag = true;
        element.selectedFlag = false;
        if (Array.isArray(element["Sections"])) {
          element["Sections"].forEach((e) => {
            e["selected"] = true;
            this.selectedStd = [];
            this.selectall = false;
            this.selectAllFlag = false;
            this.checks = false;
          });
        }
      });
    } else {
      this.checks2 = false;
      this.entireschoolFlag = false;
      this.MappedData.forEach((element) => {
        element.checkFlag = false;
        if (Array.isArray(element["Sections"])) {
          element["Sections"].forEach((e) => {
            e["selected"] = false;
            element.checkFlag = false;
          });
        }
      });
    }
    if (e.target.checked) {
      // this.selectall = true;
      this.entireschoolFlag = true;
      this.MappedData.forEach((element) => {
        this.selectedStd.push(element);
      });
      // this.selectAllSectionFlag = true;
      this.selectedStd.map((element) => {
        // element.selectedFlag = true;
        // console.log(element.standardsName);
        // console.log(element);
        this.selectParentAll(e, element.standardsName, element);
      });
    }
    else{
      this.entireschoolFlag = false;
      this.selectedStd = [];
    }

    // console.log(this.selectedStd);
  }





  selectSingleStd(e, standardId, standardsName) {
    this.En = false;
    this.isentireClass = false;
    this.parentsList.forEach((ele) => {
      ele.selected = false;
    });
    this.selectedParents = [];
    this.singleselectedParents = [];
    this.parentsList;
    this.Gs = true;
    this.selectAllSectionFlag = false;
    this.Gs = false;
    if (e.target.checked) {
      this.selectall = true;
      this.MappedData.forEach((element) => {
        if (element.standardsName == standardsName) {
          this.selectedStd.push(element);
        }
      });

      this.selectedStd.forEach(element => {
        element.Sections.sort((a, b) => {
          if (a.sectionName < b.sectionName) {
            return -1;
          }
          if (a.sectionName > b.sectionName) {
            return 1;
          }
          return 0;
        });
      });


      console.log(this.selectedStd);
    } else {
      this.isentireClass = false;
      this.En = false;
      this.selectAllFlag = false;
      this.selectedStd.forEach((g) => {
        g.Sections.forEach((element1) => {
          if (element1.StdName == standardsName) {
            element1.selected = false;
          }
        });
      });
      this.selectedStd = this.selectedStd.filter(
        (m) => m.standardsName != standardsName
      );
      if (this.selectedStd.length == 0) {
        this.selectall = false;
        this.parentsList = [];
      }
      if (Array.isArray(this.parentsList)) {
        this.parentsList = this.parentsList.filter(
          (parentsList) => parentsList.Standard !== standardsName
        );
      }
      this.selectedStd.forEach(element => {
        element.Sections.sort((a, b) => {
          if (a.sectionName < b.sectionName) {
            return -1;
          }
          if (a.sectionName > b.sectionName) {
            return 1;
          }
          return 0;
        });
      });

      console.log(this.selectedStd);


      // console.log(this.selectedStd);
    }
  }





  selectAllSection(e) {
    // console.log('selectAllSection',e);
    // console.log(this.selectedStd);
    this.parentsList;
    if (e.target.checked) {
      this.selectAllSectionFlag = true;
      this.selectedStd.map((element) => {
        element.selectedFlag = true;
        this.selectParentAll(e, element.standardsName, element);
      });
    } else {
      this.selectedStd.map((element) => {
        element.selectedFlag = false;
        this.selectParentAll(e, element.standardsName, element);
      });
      this.selectAllSectionFlag = false;
    }
  }






  async selectParentAll(e, standardName, std) {
    if (e.target.checked) {
      this.isentireClass = false;
      this.isAllSectionsSelected = true;
      for (const element of this.MappedData) {
        // console.log(element);
        if (element.standardsName == standardName) {
          // console.log(element.Sections);
          for (const childElement of element.Sections) {
            childElement.selected = true;
            await this.check(
              e,
              childElement.StdName,
              childElement.sectionName,
              childElement.SectionId,
              childElement
            );
          }
        }
      }
    } else {
      this.selectAllSectionFlag = false;
      for (const element of this.MappedData) {
        if (element.standardsName == standardName) {
          for (const childElement of element.Sections) {
            childElement.selected = false;
            await this.check(
              e,
              childElement.StdName,
              childElement.sectionName,
              childElement.SectionId,
              childElement
            );
          }
        }
      }
    }
  }







  async check(e, stdName, secName, secId, section) {
    this.En = false;
    this.isentireClass = false;
    this.parentsList.forEach((ele) => {
      ele.selected = false;
    });

    this.selectedParents = [];
    this.singleselectedParents = [];

    for (const element of this.MappedData) {
      for (const innerelement of element.Sections) {
        if (innerelement.sectionName == secName) {
          if (innerelement.selected == true && e.target.checked) {
            this.selectSectionCount = +1;
            this.sectionName = secName;
            this.standardName = stdName;
            await this.getParentsById(this.sectionName, this.standardName, secId);
          } else {
            this.isentireClass = false;
            this.selectSectionCount = -1;
            if (Array.isArray(this.parentsList)) {
              this.parentsList = this.parentsList.filter(
                (parentsList) => parentsList.sectionId !== secId
              );
            }
          }
        }
      }
    }
  }


  allParents(e) {
    this.singleselectedParents = [];
    this.selectedParents = [];
    if (e.target.checked) {
      this.isentireClass = true;
      this.allStudentFlag = true;
      this.selectedStandardSection = [];
      this.parentsList.forEach((parent) => {
        parent["selected"] = true;
        // this.sendmessage['IsParticularParent'] = false;
        this.selectedParents.push({
          Id: parent["Id"],
          parent: parent["Parent"],
          SchoolToParent: parent["SchoolToParent"],
          ChildRelation: parent["ChildRelation"],
          ChildId: parent["ChildId"],
          SectionId: parent["SectionId"],
          StandardId: parent["StandardId"],
        });
        if (
          !this.selectedStandardSection.some(
            (ele) =>
              ele.standardName == parent.Standard &&
              ele.sectionName == parent.Section
          )
        ) {
          this.selectedStandardSection.push({
            standardName: parent.Standard,
            sectionName: parent.Section,
          });
        }
      });
    } else {
      this.isentireClass = false;
      this.allStudentFlag = false;
      this.parentsList.forEach((parent) => {
        parent["selected"] = false;
      });
    }


  }



  public selectedParent(event, parent) {
    parent.DRCEnable1 = event.target.checked ? 1 : 0;
    // console.log(parent);
    if (event.target.checked) {
      if (Array.isArray(this.parentsList)) {
        var selectedParent = this.parentsList.filter(
          (parentsList) => parentsList.ChildId == parent.ChildId
        );
        // console.log("selectedParent", selectedParent);
      }
      this.selectedParents.push({
        Id: selectedParent[0]["Id"],
        ChildId: selectedParent[0]["ChildId"],
        parent: selectedParent[0]["Parent"],
        ParentName2: selectedParent[0]["ParentName2"],
        SchoolToParent: selectedParent[0]["SchoolToParent"],
        ChildRelation: selectedParent[0]["ChildRelation"],
        SectionId: selectedParent[0]["SectionId"],
        StandardId: selectedParent[0]["StandardId"],
        ChildName: selectedParent[0]["firstName"],
      });
      this.singleselectedParents = this.selectedParents;
      // console.log("this.selectedParents", this.selectedParents);
    } else {
      this.En = false;
      this.isentireClass = false;
      this.selectedParents = this.selectedParents.filter(
        (selectedParents) => selectedParents.ChildId !== parent.ChildId
      );
      this.singleselectedParents = this.selectedParents;
      // console.log("selectedParents", this.singleselectedParents);
    }

    // if (event.target.checked) {
    //   this.selectedParentsList.push(parent.ChildId);
    // } else {
    //   const index = this.selectedParentsList.indexOf(parent.ChildId);
    //   if (index > -1) {
    //     this.selectedParentsList.splice(index, 1);
    //   }
    // }

    // console.log(this.parentsList);


  }

  //
  // private getParentsById(sectionName, standardName, secId) {
  //   console.log(this.selectedYear);
  //   this.noticeboardService
  //     .getParentsByClass(sectionName, standardName)
  //     .finally(() => {})
  //     .subscribe(
  //       (response) => {
  //         console.log(response);
  //         if (Array.isArray(response)) {
  //           response.forEach((parent) => {
  //             parent["sectionId"] = secId;
  //           });
  //         }
  //         this.parentsList = this.parentsList.concat(response);
  //         this.parentsList = this.parentsList.reduce((unique, o) => {
  //           if (!unique.some((obj) => obj.ChildId === o.ChildId)) {
  //             unique.push(o);
  //           }
  //
  //           return unique;
  //         }, []);
  //
  //         this.isAllSectionsSelected = false;
  //         this.parentsList.sort(this.dynamicSort("firstName"));
  //         this.parentsList.sort((a, b) =>
  //           ("" + a.Standard + a.Section).localeCompare(
  //             b.Standard + b.Section,
  //             undefined,
  //             { numeric: true }
  //           )
  //         );
  //         this.parentsListData = this.parentsList
  //           .map((item) => item.Standard + item.Section)
  //           .filter((value, index, self) => self.indexOf(value) === index);
  //       },
  //
  //       (error) => {}
  //     );
  // }


  private getParentsById(sectionName, standardName, secId) {
    // console.log(this.selectedYear);
    this.noticeboardService
      .getParentsByClassFilterQuanta(this.selectedYear.YearId, sectionName, standardName)
      .finally(() => {})
      .subscribe(
        (response) => {
          // console.log(response['items']);
          if (Array.isArray(response['items'])) {
            response['items'].forEach((parent) => {
              parent["sectionId"] = secId;
            });
          }
          this.parentsList = this.parentsList.concat(response['items']);
          this.parentsList = this.parentsList.reduce((unique, o) => {
            if (!unique.some((obj) => obj.ChildId === o.ChildId)) {
              unique.push(o);
            }

            return unique;
          }, []);




          this.parentsList.sort((a, b) => {
            if (a.ChildFirstName < b.ChildFirstName) {
              return -1;
            }
            if (a.ChildFirstName > b.ChildFirstName) {
              return 1;
            }
            return 0;
          });


          this.isAllSectionsSelected = false;
          this.parentsList.sort(this.dynamicSort("ChildLastName"));
          this.parentsList.sort((a, b) =>
            ("" + a.Standard + a.Section).localeCompare(
              b.Standard + b.Section,
              undefined,
              { numeric: true }
            )
          );
          this.parentsListData = this.parentsList
            .map((item) => item.Standard + item.Section)
            .filter((value, index, self) => self.indexOf(value) === index);


          this.parentsList.forEach(parent => {
            parent.selected = parent.DRCEnable === 1;
          });

        },



        (error) => {}
      );

  }




  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      if (sortOrder == -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    };
  }


  submit() {
    // if (this.entireschoolFlag || this.selectAllSectionFlag || this.allStudentFlag) {
    //   console.log(this.parentsList);
    //   this.selectedParentsList = this.parentsList.map(parent => parent.ChildId);
    //   console.log(this.selectedParentsList);
    // }else{
    //   // console.log(this.selectedParentsList);
    // }
    console.log(this.parentsList);

    let parentdrcenable = this.parentsList.map(parent => ({
      ChildId: parent.ChildId,
      drcenable1: parent.DRCEnable1,
      drcenable2: parent.DRCEnable2,
      drcenable3: parent.DRCEnable3
    }));

    // console.log(parentdrcenable);

    var payload = {
      AcademicYearId: this.selectedYear.YearId,
      parentdrcenable: parentdrcenable
    };

    console.log(payload);

    this.dataAnalyticsService
      .ParentAccessControl(payload)
      .finally(() => {})
      .subscribe(
        (response) => {
          console.log(response);
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: " Changes saved Successfully",
          });
          this.selectedStd = [];
          this.parentsList = [];
          this.selectedParentsList = [];
          this.entireschoolFlag = false;
          this.selectAllSectionFlag = false;
          this.allStudentFlag = false;
          this.ngOnInit();
        },
        (error) => {}
      );
  }


  selectedParent2(event, parent: any) {
    parent.DRCEnable2 = event.target.checked ? 1 : 0;
    // console.log(parent);
    if (event.target.checked) {
      if (Array.isArray(this.parentsList)) {
        var selectedParent = this.parentsList.filter(
          (parentsList) => parentsList.ChildId == parent.ChildId
        );
        // console.log("selectedParent", selectedParent);
      }
      this.selectedParents.push({
        Id: selectedParent[0]["Id"],
        ChildId: selectedParent[0]["ChildId"],
        parent: selectedParent[0]["Parent"],
        ParentName2: selectedParent[0]["ParentName2"],
        SchoolToParent: selectedParent[0]["SchoolToParent"],
        ChildRelation: selectedParent[0]["ChildRelation"],
        SectionId: selectedParent[0]["SectionId"],
        StandardId: selectedParent[0]["StandardId"],
        ChildName: selectedParent[0]["firstName"],
      });
      this.singleselectedParents = this.selectedParents;
      // console.log("this.selectedParents", this.selectedParents);
    } else {
      this.En = false;
      this.isentireClass = false;
      this.selectedParents = this.selectedParents.filter(
        (selectedParents) => selectedParents.ChildId !== parent.ChildId
      );
      this.singleselectedParents = this.selectedParents;
      // console.log("selectedParents", this.singleselectedParents);
    }

    // if (event.target.checked) {
    //   this.selectedParentsList.push(parent.ChildId);
    // } else {
    //   const index = this.selectedParentsList.indexOf(parent.ChildId);
    //   if (index > -1) {
    //     this.selectedParentsList.splice(index, 1);
    //   }
    // }
    //
    // console.log(this.selectedParentsList);

    // console.log(this.parentsList);


  }

  selectedParent3(event, parent: any) {
    parent.DRCEnable3 = event.target.checked ? 1 : 0;
    // console.log(parent);
    if (event.target.checked) {
      if (Array.isArray(this.parentsList)) {
        var selectedParent = this.parentsList.filter(
          (parentsList) => parentsList.ChildId == parent.ChildId
        );
        // console.log("selectedParent", selectedParent);
      }
      this.selectedParents.push({
        Id: selectedParent[0]["Id"],
        ChildId: selectedParent[0]["ChildId"],
        parent: selectedParent[0]["Parent"],
        ParentName2: selectedParent[0]["ParentName2"],
        SchoolToParent: selectedParent[0]["SchoolToParent"],
        ChildRelation: selectedParent[0]["ChildRelation"],
        SectionId: selectedParent[0]["SectionId"],
        StandardId: selectedParent[0]["StandardId"],
        ChildName: selectedParent[0]["firstName"],
      });
      this.singleselectedParents = this.selectedParents;
      // console.log("this.selectedParents", this.selectedParents);
    } else {
      this.En = false;
      this.isentireClass = false;
      this.selectedParents = this.selectedParents.filter(
        (selectedParents) => selectedParents.ChildId !== parent.ChildId
      );
      this.singleselectedParents = this.selectedParents;
      // console.log("selectedParents", this.singleselectedParents);
    }

    // if (event.target.checked) {
    //   this.selectedParentsList.push(parent.ChildId);
    // } else {
    //   const index = this.selectedParentsList.indexOf(parent.ChildId);
    //   if (index > -1) {
    //     this.selectedParentsList.splice(index, 1);
    //   }
    // }
    //
    // console.log(this.selectedParentsList);

    // console.log(this.parentsList);

  }

  selectAllStudentsFirst(e) {
    if (e.target.checked) {
      this.allStudentsFirst = true;
      this.parentsList.forEach(element => {
        if (element.DRCEnable1 === 0 || element.DRCEnable1 === null) {
          element.DRCEnable1 = 1;
        }
      });
    } else {
      this.allStudentsFirst = false;
      this.parentsList.forEach(element => {
        if (element.DRCEnable1 === 1 || element.DRCEnable1 === null) {
          element.DRCEnable1 = 0;
        }
      });
    }
  }

  selectAllStudentsSecond(e) {
    if (e.target.checked) {
      this.allStudentsSecond = true;
      this.parentsList.forEach(element => {
        if (element.DRCEnable2 === 0 || element.DRCEnable2 === null) {
          element.DRCEnable2 = 1;
        }
      });
    } else {
      this.allStudentsSecond = false;
      this.parentsList.forEach(element => {
        if (element.DRCEnable2 === 1 || element.DRCEnable2 === null) {
          element.DRCEnable2 = 0;
        }
      });
    }
  }

  selectAllStudentsThird(e) {
    if (e.target.checked) {
      this.allStudentsThird = true;
      this.parentsList.forEach(element => {
        if (element.DRCEnable3 === 0 || element.DRCEnable3 === null) {
          element.DRCEnable3 = 1;
        }
      });
    } else {
      this.allStudentsThird = false;
      this.parentsList.forEach(element => {
        if (element.DRCEnable3 === 1 || element.DRCEnable3 === null) {
          element.DRCEnable3 = 0;
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/ParentDRCAccess/ParentDRCAccess.component.ts